/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VerticalSplit from "./../../../Basis/Components/VerticalSplit";

const ExportvorlagenView = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Views/ExportvorlagenView"));
const ExportvorlagenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Components/ExportvorlagenBreadcrumb"));
const ExportvorlageView = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Views/ExportvorlageView"));
const ExportvorlagenNavigationView = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Views/ExportvorlagenNavigationView"));
const ExportvorlageBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Components/ExportvorlageBreadcrumb"));
const ExportvorlageDetailsView = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Views/ExportvorlageDetailsView"));
const ExportvorlageSpaltenUndFilterView = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Views/ExportvorlageSpaltenUndFilterView"));
const ExportvorlageSpaltenUndFilterBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Exporte" */"../Components/ExportvorlageSpaltenUndFilterBreadcrumb"));

export const EXPORTVORLAGEN_PATH = "/exportvorlagen";
export const EXPORTVORLAGE_PATH = "/exportvorlage/:exportvorlageId";

export const exporteRouterDefintions: Array<AppRouterDefinition> = [
    {
        path: EXPORTVORLAGEN_PATH,
        exact: true,
        render: () => <ExportvorlagenView />,
        createBreadcrumbs: () => [<ExportvorlagenBreadcrumb />],
    },
    {
        path: EXPORTVORLAGE_PATH,
        render: (props) => (
            <VerticalSplit
                left={() => <ExportvorlagenNavigationView {...props} />}
                right={() => <ExportvorlageView {...props} />}
            />
        ),
        createBreadcrumbs: (props) => [
            <ExportvorlagenBreadcrumb />,
            <ExportvorlageBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: EXPORTVORLAGE_PATH,
        path: EXPORTVORLAGE_PATH,
        exact: true,
        render: (props) => <ExportvorlageDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <ExportvorlagenBreadcrumb />,
            <ExportvorlageBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: EXPORTVORLAGE_PATH,
        path: `${EXPORTVORLAGE_PATH}/spaltenUndFilter`,
        exact: true,
        render: (props) => <ExportvorlageSpaltenUndFilterView {...props} />,
        createBreadcrumbs: (props) => [
            <ExportvorlagenBreadcrumb />,
            <ExportvorlageBreadcrumb {...props} />,
            <ExportvorlageSpaltenUndFilterBreadcrumb {...props} />,
        ],
    },
]
